export class SchemaxEmployeesModel{
    employeeCode :string;
    employeeName :string;
    contactNumber:string;
    constructor(employeeCode :string,employeeName :string,contactNumber:string){
        this.employeeCode = employeeCode;
        this.employeeName = employeeName;
        this.contactNumber = contactNumber;
    }
}